import { ISingleOrder } from '@alberta/konexi-shared';
import { Inject, Injectable } from '@angular/core';
import { BaseComponentModel } from 'src/app/common/component-model/base-component-model';
import { ComponentModelDependencies } from 'src/app/common/component-model/component-model-dependencies';
import { ComponentModelInfo } from 'src/app/common/component-model/component-model-info';
import { SingleOrderModelName } from 'src/app/shared/models/model-names';

@Injectable({ providedIn: 'root' })
export class SingleOrderComponentModel extends BaseComponentModel<ISingleOrder> {
  /**
   * ComponentModel for all careproposal relevant actions and dependencies
   */
  constructor(
    @Inject(ComponentModelDependencies) _componentModelDependencies: ComponentModelDependencies,
    @Inject(ComponentModelInfo) componentModelInfo: ComponentModelInfo
  ) {
    super(SingleOrderModelName, _componentModelDependencies, componentModelInfo);
  }
}
